/* eslint-disable */
<template>
  <v-container ma-0 class="main-info">
    <v-layout wrap justify-space-between>
      <v-flex d-flex xs12 md6 pt-2 :class="{'pr-2': $vuetify.breakpoint.mdAndUp}">
        <v-card min-width="200">
          <swiper
            :options="swiperOption"
            v-if="equipmentData.PassportImages && equipmentData.PassportImages.length"
          >
            <swiper-slide
              contain
              v-for="(equipmentImage,i) in equipmentData.PassportImages"
              :key="i"
              @click.native="show"
              style="display:flex; min-height: 50vh"
            >
              <img :src="equipmentImage" class="slider" />
            </swiper-slide>
            <div class="swiper-pagination" slot="pagination"></div>
          </swiper>
          <v-img v-else :src="baseUrl + 'img/equipment.png'"></v-img>
          <v-spacer></v-spacer>
          <v-card-title primary-title>
            <div>
              <h3 class="headline mb-0">{{equipmentData.Name}}</h3>
              <div>{{equipmentData.Description}}</div>
            </div>
          </v-card-title>
        </v-card>
      </v-flex>
      <v-flex d-flex xs12 md6 pt-2 v-if="equipmentData.EquipmentId">
        <v-list subheader dense>
          <v-subheader
            d-flex
            class="primary headline text-uppercase"
          >{{ $t('equipment.mainInfo.status') }}</v-subheader>
          <v-chip
            :color="equipmentData.StatusColor"
            disabled
            style="width:99%; margin:0.5%"
            class="white--text subheading"
          >{{equipmentData.StatusCode}}</v-chip>

          <template v-for="(item,i) in equipmentMainInfoListData">
            <v-subheader
              v-if="item.header"
              :key="i"
              class="primary headline text-uppercase"
            >{{ item.title }}</v-subheader>
            <v-list-tile v-else :key="i" avatar>
              <v-list-tile-avatar style="heigth:auto">
                <v-icon :color="item.color">{{ item.icon }}</v-icon>
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title style="white-space:normal">{{ item.title }}</v-list-tile-title>
                <v-list-tile-sub-title
                  style="white-space:normal"
                >{{ $vuetify.breakpoint.mdAndUp ? item.info : item.subtitle }}</v-list-tile-sub-title>
              </v-list-tile-content>
              <v-list-tile-action
                v-if="$vuetify.breakpoint.mdAndUp"
                style="white-space:normal"
              >{{ item.subtitle }}</v-list-tile-action>
            </v-list-tile>
          </template>
          <v-spacer />
          <v-layout v-if="isAuthenticated" row>
            <v-btn
              v-if="equipmentData.ConditionParameters && equipmentData.ConditionParameters.length"
              dark
              color="blue"
              @click.native.stop="$router.push({ name: 'inspectionsbyequipment', params: { equipmentId: equipmentData.EquipmentId }  })"
            >
              <span>{{$t('equipment.inspections.title')}}</span>
            </v-btn>
            <v-dialog
              lazy
              v-if="equipmentData.IiotUiUrl && equipmentData.IiotUiUrl.length"
              width="1000"
            >
              <v-btn slot="activator" dark color="red">
                <span>IIoT Data</span>
              </v-btn>
              <v-card>
                <iframe :src="equipmentData.IiotUiUrl" height="650" width="100%"></iframe>
              </v-card>
            </v-dialog>
          </v-layout>
        </v-list>
      </v-flex>
      <viewer :images="equipmentData.PassportImages" @inited="inited" style="display:none;">
        <img v-for="src in equipmentData.PassportImages" :src="src" :key="src" />
      </viewer>
    </v-layout>
  </v-container>
</template>

<script>
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'

export default {
  components: {
    swiper,
    swiperSlide
  },
  name: 'MainInfo',
  props: {
    equipmentData: Object
  },
  data() {
    return {
      swiperOption: {
        slidesPerView: 1,
        speed: 1000,
        centeredSlides: true,
        grabCursor: true,
        autoplay: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        }
      }
    }
  },
  computed: {
    loading() {
      return this.$store.state.base.loading
    },
    // equipmentData() {
    //   return this.$store.state.equipmentData;
    // },
    equipmentMainInfoListData() {
      return this.$store.getters.equipmentMainInfoListData
    },
    hideImageControls() {
      return (
        !this.$store.state.equipmentData.PassportImages ||
        this.$store.state.equipmentData.PassportImages.length <= 1
      )
    },
    baseUrl() {
      return process.env.BASE_URL
    },
    isAuthenticated() {
      return this.$store.getters.isAuthenticated
    }
    /*equipmentAdditional(){
      return this.$store.getters.equipmentAdditional
    }*/
  },
  methods: {
    inited(viewer) {
      this.$viewer = viewer
    },
    show() {
      this.$viewer.show()
    }
  }
}
</script>


<style scoped>
.slider {
  min-width: 15vw;
  min-height: 30vh;
  max-height: 50vh;
  max-width: 100%;
  margin: auto;
}
.main-info >>> .v-list--dense .v-list__tile--avatar {
  height: auto;
}
.main-info >>> .v-list__tile__avatar {
  min-width: 10px;
  padding-right: 5px;
}
.main-info >>> .v-avatar {
  width: auto !important;
  padding-right: 5px;
}
.main-info >>> .v-responsive {
  height: auto !important;
}
</style>
